<template>
  <div>
    <h2 class="text-center text-3xl md:text-4xl text-black mb-lg">
      <span data-test="title" data-testid="public-page-title-text">
        {{ title }}
      </span>
    </h2>
    <p
      v-if="info"
      data-test="info"
      class="text-sm mb-sm text-center text-black">
      {{ info }}
    </p>
    <hr
      v-if="showHR"
      data-test="hr"
      class="mt-sm mb-sm"
    />
  </div>
</template>

<script>
export default {
  name: 'PublicPageHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    showHR: {
      type: Boolean,
      required: false,
      default: false,
    },
    info: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>
